import {IProjectSettings} from "./Interfaces";
import {Plugin} from "./Main";
import {
    app,
    globalMatrix,
    IItem,
    ml,
    matrixSession,
    IDataStorage,
    UIToolsConstants,
    ISearchResult, matrixsdk, refLinkStyle, refLinkTooltip
} from "../../../sdk/client";
import {IDashboardPage, IDashboardParametersBase} from "../../../sdk/plugins/interfaces";
import {Project} from "../../../sdk/objects/Project";
import {ReferenceTools} from "../../../sdk/ui";
import {ITraceGraphData, ITraceRule, ITraceRuleArray} from "./Interfaces";

export interface  IDashboardParameters extends IDashboardParametersBase{
    cat: string;
}

// eslint-disable-next-line no-unused-vars
export class DashboardPage implements IDashboardPage<IDashboardParameters> {
    settings: IProjectSettings;

    _root: JQuery;



    constructor(private project: Project, private projectStorage: IDataStorage,private popupModeOrControl = false, private currentFolder:string = undefined) {
        this.settings = {...Plugin.config.projectSettingsPage.defaultSettings, ...globalMatrix.ItemConfig.getSettingJSON(Plugin.config.projectSettingsPage.settingName, {})};
    }

    /** Customize static HTML here */
    private getDashboardDOM(): JQuery {
        return $(this.dashboardDOM);
    }

    currentCat = "";


    public AllCoveredColor: string = UIToolsConstants.CIColors.GreenSushi.color;
    public MissingUp: string = UIToolsConstants.CIColors.YellowBrightSun.color;
    public MissingDown: string = UIToolsConstants.CIColors.OrangeYellow.color;
    public MissingAll: string = UIToolsConstants.CIColors.RedPersimmon.color;

    public SelectionChanged(cat: string, folder?: string) {
        let that = this;

        if (cat == undefined) {
            return;
        }

        that.currentCat = cat ;
        that.currentFolder = folder;
        if( cat !="")
            $("#selectedCat", app.itemForm).text(cat);
        else
            $("#selectedCat", app.itemForm).text("All");


        //No save in case of popup
        if (!this.popupModeOrControl)
            that.setLastSelection(cat);


        $("#waitForIt",that._root).html("");
        $("#waitForIt",that._root).append(ml.UI.getSpinningWait("please wait..."));

        $(".spinningWait",that._root).show();

        $('.addedNotifRow',that._root).remove();



        this.getItems(cat, folder);
    }
    getItems(cat: string, folder?: string) {
        let that = this;
        let query =[];
        if(cat != "")
        {
            query.push( " category=\"" + cat + '"');
        }
        else
        {
            let categories = globalMatrix.ItemConfig.getTraceConfig().rules.map(o => { return o.category });
            query.push( "("+ categories.filter((o:any) => { return that.rules[o].downMust.length!=0 || that.rules[o].upMust.length !=0 }).map(o=>{ return "CATEGORY = \"" + o + "\"" ; }).join(" OR ") + ")" )
        }
        if (folder && folder != "" )  {
            query.push("folderm=" + folder);
        }
        const fullQuery = "mrql:" + query.join(" AND ");
        const labelFilter = ml.LabelTools.getFilter();
        const labelFilterArg = (labelFilter && labelFilter.length) > 0 ? labelFilter : undefined;
        let res: Promise<ISearchResult[]> = matrixsdk.search(fullQuery, false, true, false, labelFilterArg);
        res.then((results: ISearchResult[]) => {
            let output = that.renderTraceTable(results);
            $("#TRACEContentPanel",that._root).show();
            $("#waitForIt",that._root).html("");
            setTimeout((o:any) => { that.drawChart(output)},100)
        });
    }
    start() {
        let that = this;

        // No automatic start in case of popup
        if (that.popupModeOrControl)
            return;
        // Get last opened Notif for that user.

        let cat = that.getLastSelection();
        that.SelectionChanged(cat)
    }
    getLastSelection(): string {

        let value = globalMatrix.projectStorage.getItem("lastTRACESelection");
        if (value != undefined && value != "")
            return value;
        return "";

    }
    setLastSelection(sel: string) {
        globalMatrix.projectStorage.setItem("lastTRACESelection", sel);
    }

    private currentFilter = "";
    filterByType(filter:any)
    {
        let that = this;
        this.currentFilter = filter.type;
        if( filter.type == "")
        {
            //Show all
            $("#itemTraceList tbody tr",that._root).show();

        }
        else
        {
            $("#itemTraceList tbody tr",that._root).hide();
            $("#itemTraceList tbody tr[data-type='"+filter.type+"']",that._root).show();

        }


    }
    renderTraceTable(needles: ISearchResult[]): ITraceGraphData {
        let that = this ;
        let data:ITraceGraphData = {
            allItems:[],
            itemsWithAllCoverageMissing:[],
            itemsWithDownTraceMissing:[],
            itemWithUpTraceMissing:[],
            hasDownMust:false,
            hasUpMust:false,

        };
        let table = $("#itemTraceList ",that._root);
        let template = $(".template", table);
        $(".addedItem", table).remove();
        $(".uplinks",that._root).hide();
        $(".downlinks",that._root).hide();

        data.hasDownMust  =false
        data.hasUpMust= false;



        if (needles != undefined) {
            needles.forEach((needle: ISearchResult) => {

                let rule: ITraceRule = that.rules[ml.Item.parseRef(needle.itemId).type ];


                let jqueryItem = template.clone();

                let missingDown = false;
                let missingUp = false;
                jqueryItem.attr("data-id", needle.itemId);

                jqueryItem = jqueryItem.removeClass("template").removeClass("hidden").addClass("addedItem");
                $(".title", jqueryItem).html("");

                let itemId = needle.itemId;
                let itemLink = $(".linkTrace",jqueryItem);

                let link = $("<div></div>").refLink({
                    id: itemId, title: needle.title , style: refLinkStyle.link,  tooltip: refLinkTooltip.html, hideTitle:false
                })
                itemLink.click(() => {
                    let rt = new ReferenceTools();
                    app.getItemAsync(itemId).then((asyncItem) => {
                        //TODO :find out if i can edit or not.
                        rt.showReferenceDialog({ item: asyncItem, canEdit: true, callback:(item)=>{
                                //Refresh all
                                that.SelectionChanged(that.currentCat, that.currentFolder);
                            }});

                    })
                });
                $(".title", jqueryItem).append(link);
                $(".title", jqueryItem).data("ref",itemId);
                //$(".downlink",item).html("");
                data.allItems.push(needle);
                // Let's check each rule

                let downLinkCount = 0 ;
                let details:string[] = [];
                // Let's check each rule
                rule.downMust.forEach((rule) => {
                    //Build mx-rule
                    let count = 0;
                    data.hasDownMust = true;
                    if (needle.downlinks != undefined) {
                        needle.downlinks.forEach(downItem => {
                            let cat = downItem.substring(0, downItem.indexOf("-"));
                            if (rule.indexOf(cat) != -1)
                            {
                                count++;
                                downLinkCount++;
                            }
                        });
                    }
                    if (count == 0) {
                        missingDown = true ;
                        details.push( "missing downlink to " + rule.join(","));
                    }
                })
                $(".downlinks", jqueryItem).text(downLinkCount)

                let uplinkCount = 0

                // Let's check each rule
                rule.upMust.forEach((rule) => {
                    //Build mx-rule
                    let count = 0;
                    data.hasUpMust = true;

                    if (needle.uplinks != undefined) {
                        needle.uplinks.forEach(upItem => {
                            let cat = upItem.substring(0, upItem.indexOf("-"));
                            if (rule.indexOf(cat) != -1)
                            {
                                count++;
                                uplinkCount++;
                            }
                        });
                    }
                    if (count == 0) {
                        missingUp = true ;
                        details.push( "missing uplink to " + rule.join(","));

                    }
                })
                $(".uplinks", jqueryItem).text(uplinkCount)


                $("tbody", table).append(jqueryItem);

                $(".linkTrace",jqueryItem).css("color",this.AllCoveredColor);

                jqueryItem.attr("data-type","missingNone");


                if((missingDown) && (missingUp))
                {
                    data.itemsWithAllCoverageMissing.push(needle);
                    $(".linkTrace",jqueryItem).css("color",this.MissingAll);
                    jqueryItem.attr("data-type","missingAll");

                }
                if((!missingDown) && (missingUp))
                {
                    data.itemWithUpTraceMissing.push(needle);
                    $(".linkTrace",jqueryItem).css("color",this.MissingUp);
                    jqueryItem.attr("data-type","missingUp");


                }
                if((missingDown) && (!missingUp))
                {
                    data.itemsWithDownTraceMissing.push(needle);
                    $(".linkTrace",jqueryItem).css("color",this.MissingDown);
                    jqueryItem.attr("data-type","missingDown");


                }

                $(".details", jqueryItem).text(details.join(", "));
            });
        }
        if( data.hasDownMust)
        {
            $(".downlinks",that._root).show();
        }
        if( data.hasUpMust)
        {
            $(".uplinks",that._root).show();
        }


        $("#itemTraceList tbody tr").show();
        that.filterByType({type:that.currentFilter});
        return data;

    }

    private hasTraceability(categories:string[], rules:ITraceRuleArray):boolean {
        let traceRules = categories.filter((o:any) => {
            return rules[o].downMust.length!=0 || rules[o].upMust.length !=0 });
        return traceRules.length > 0;
    }


    render():JQuery{

        let that = this;
        that.rules = DashboardPage.getRules();
        let categories = globalMatrix.ItemConfig.getTraceConfig().rules.map(o => { return o.category });

        this._root = this.getDashboardDOM();

        // If a project has no traceability rules, we'll only render a simple message.
        if (!this.hasTraceability(categories, that.rules)) {
            that._root.html('<p style="padding: 5px;">No traceability rules are configured.</p>');
            return that._root;
        }

        let baseControl = $("<div id='itemSelectionTRACE'/>")

        $(".toolbarButtons",app.itemForm).append(baseControl);

        let select = $(`<div class="dropdown navbar-right" style="">
                <button class="btn btn-xs dropdown-toggle" type="button" data-toggle="dropdown">
                    <span id="selectedCat" >CAT</span>&nbsp;
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                </ul>
                </div>`);


        baseControl.append(select);

        if (that.popupModeOrControl) {
            baseControl.hide();
        }
        //Table filter
        $("#TRACEInputFilter", this._root).on("keyup", function (e) {
            let value = $(e.target).val().toLowerCase();
            $("#itemTraceList tbody tr").show();

            $("#itemTraceList tbody tr").each(function (index, elem) {
                if(($(elem).text().toLowerCase().indexOf(value) == -1))
                {
                    $(elem).hide();
                }
            });
        });

        if (!that.popupModeOrControl) {
            setTimeout((o:any) => that.start(), 10);
        }
        categories.filter(cat => { return that.rules[cat].upMust.length != 0 || that.rules[cat].downMust.length != 0 }) .forEach(cat => {
            let item = $(`<li class="cat" data-cat="${cat}"><a href="javascript:void(0)">${cat}</a></li>`).click(function(){
                that.SelectionChanged(cat);
            });
            $(".dropdown-menu",select).append(item);
        });

        let allItem = $(`<li class="cat" data-cat=""><a href="javascript:void(0)">All</a></li>`).click(function(){
            that.SelectionChanged("");
        });
        $(".dropdown-menu",select).prepend(allItem);

        this.installCopyButtons("Traceability overview");
        return  this._root;
    }

    /** Add interactive element in this function */
    renderProjectPage() {
        app.itemForm.append(
            ml.UI.getPageTitle(
                Plugin.config.dashboard.title,
                () => {
                    return this._root;
                },
                () => {
                    this.onResize();
                }
            )
        );
        app.itemForm.append(this.render());
    }






    onResize() {
        /* Will be triggered when resizing. */
    }

    static getRules():ITraceRuleArray
    {
        let rules:ITraceRuleArray = {};
        globalMatrix.ItemConfig.getTraceConfig().rules.forEach((o: any) => {
            rules[o.category]  = {
                cat: o.category,
                upMust: o.up_rules.filter((up:any) => { return up.rule == "must_have" })
                    .map((up:any) => { return up.any_of }),
                upCan: o.up_rules.filter((up:any) => { return up.rule == "can_have" })
                    .map((up:any) => { return up.any_of }),
                downMust: o.down_rules.filter((dw:any) => { return dw.rule == "must_have" })
                    .map((down:any) => { return down.any_of }),
                downCan: o.down_rules.filter((dw:any) => { return dw.rule == "can_have" })
                    .map((down:any) => { return down.any_of })
            }
        });
        return rules;
    }

    rules: ITraceRuleArray;
    chart: c3.ChartAPI;

    installCopyButtons(title: string) {
        let that = this;

        let savedWidth = 0;
        ml.UI.copyBuffer($("#tracePieChartTitle",this._root), "copy  to clipboard", $(this._root), this._root, (copied: JQuery) => {

            $("#traceTableHeader i",copied).remove();
            $("#itemTraceList th:first-of-type",copied).remove();
            $("#itemTraceList tr.template",copied).remove();
            $(".title", copied).each( (i,item)=>{ $(item).text($(item).data("ref") +"!")  } );
            $(".addedItem td:first-of-type",copied).remove();

            ml.UI.fixC3ForCopy(copied);
            $("#TRACEInputFilter",copied).remove();
            $("#tracePieChartTitle", copied).html("<h1>" + title + "</h1> <span> <b> Date:</b> " + ml.UI.DateTime.renderCustomerHumanDate(new Date()) +  "<br/>");

        },"",()=>{
            savedWidth = $("#TRACEContentPanel svg").width();
            that.chart.resize({width:590});
        },()=>{
            that.chart.resize({width:savedWidth})

        });


    }
    private drawChart(inputData: ITraceGraphData) {
        let that = this;
        let colors:string[]=[];
        let colums:any[] = [];
        colums.push(["All covered", inputData.allItems.length - inputData.itemWithUpTraceMissing.length - inputData.itemsWithAllCoverageMissing.length - inputData.itemsWithDownTraceMissing.length, UIToolsConstants.CIColors.GreenSushi.color, "missingNone"]);
        if( inputData.hasUpMust)
        {
            colums.push(["Missing up link", inputData.itemWithUpTraceMissing.length, UIToolsConstants.CIColors.YellowBrightSun.color, "missingUp"]);

        }
        if( inputData.hasDownMust)
        {
            colums.push(["Missing down link", inputData.itemsWithDownTraceMissing.length, UIToolsConstants.CIColors.OrangeYellow.color, "missingDown"])

        }
        colums.push(["Missing up and down links", inputData.itemsWithAllCoverageMissing.length, UIToolsConstants.CIColors.RedPersimmon.color, "missingAll"])

        colums.forEach((col)=>{
            col[0]+= " ("+col[1] + ")"
        });
        if(this.popupModeOrControl)
        {

        }
        that.chart = c3.generate({
            bindto:  $("#tracePieChart",this._root)[0],
            data: {
                columns: colums,
                type : "donut",
                onclick: function (d , i) {
                    that.filterByType({ type: colums[d.index][ colums[d.index].length -1] });
                },
                color:  function (color, d:string) {
                    let c = colums.filter((item)=>{return item[0] == d});
                    if( c.length>0)
                    {
                        return c[0][c[0].length -2];
                    }
                    return color;
                }

            },
            donut: {
                label: {
                    format: function (value, ratio, id) {
                        return (value);
                    }
                }
            },
            legend: {
                item: {
                    onclick: function (id) {

                        let c = colums.filter((item)=>{return item[0] == id});
                        if( c.length>0)
                        {
                            that.filterByType({ type: c[0][c[0].length -1] })
                        }

                    }
                },
                position:'inset',
                inset: {

                    anchor: "top-right"
                }
            },
            tooltip: {
                format: {
                    value: function (value:any, ratio:any, id:any, index:any) { return value; }
                }
            },
        });

        $("#tracePieChart .c3-event-rects").click(function(){
            that.filterByType({type:""});
        });


        return;

    }


    private dashboardDOM = `<div class="panel-body-v-scroll fillHeight">
        <style>
        .chart {
            width: 90%;
            min-height: 350px;
            cursor:pointer;
        }
        .bigChart
        {
            min-height:700px;
        }
        </style>
        <div class="row" id="waitForIt" class="spinningWait"></div>
        <div class="panel-body" id="TRACEContentPanel">

            <div id="">
                <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title" id="tracePieChartTitle">Overview</h3>
                </div>
                <div class="panel-body">
                    <div class="traceTitleForCopy"></div>
                    <div id="tracePieChart" class="chart"></div>
                </div>
        </div></div>
        <div id="traceContent" >
        <div class="row doNotCopy">
            <div class="col-lg-3 ">
                <h3 id="TraceTableHeader">Item list</h3>
            </div>
            <div class=" col-lg-7">
            </div>
            <div class=" col-lg-2">
            <input type="text" id="TRACEInputFilter" style="margin-bottom:10px;" placeholder="filter..." class="doNotCopy  form-control"></input>
            </div>
        </div>
        <div class="traceTitleForCopy"></div>
            <table id="itemTraceList" class="table table-condensed table-borderless table-hover">
               <thead>
                <tr>
                    <th style="width:20px"> </th>
                    <th> id</th>
                    <th class="uplinks" style="width:40px"> Uplinks</th>
                    <th class="downlinks" style="width:40px"> Downlinks</th>
                    <th> Details</th>
                </tr>
               </thead>
               <tbody>
                    <tr class="template hidden">
                        <td style="display:flex"><i class="fal fa-sitemap linkTrace"/></td>
                        <td class="title" >MyITEM : my title ablash </td>
                        <td class="uplinks"> xx</td>
                        <td class="downlinks"> xx</td>
                        <td class=""> <small class="details">Missing TC and SPEC</small></td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
        </div>
        `
}
